export default __webpack_public_path__ + "static/media/art3.767a4264.png";